import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	TABLET_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities-index";

export const LogosWrapper = styled.div`
	padding: 60px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	overflow: hidden;
	width: 100%;
	h5.header {
		width: 100%;
		display: block;
		font-weight: ${FONT_WT_MEDIUM};
		font-size: 28px;
		line-height: 28px;
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin: 0 0 50px 0;
		padding: 0 10px;
	}
	.logos-container {
		display: inline-flex;
		overflow: auto;
		flex-wrap: nowrap;
		margin: 10px auto;
		align-items: center;
		padding-bottom: 10px;
		img {
			margin-right: 20px;
			max-height: 45px;
		}
	}
	.logos-container-flex {
		display: flex;
		overflow: auto;
		flex-wrap: wrap;
		justify-content: center;
		margin: 10px 200px;
		align-items: center;
		padding-bottom: 10px;
		img {
			margin-right: 20px;
			max-height: 80px;
			margin-bottom: 40px;
		}
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 30px;
		h5.header {
			font-size: 26px;
		}
		.logos-container-flex {
			margin: 10px 0px;
			img {
				height: 80px;
			}
		}
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		${(props) => (props.showInTabletAndMobile ? "" : "display: none")}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
		.logos-container-flex {
			display: inline-flex;
			-webkit-justify-content: left;
			overflow: auto;
			flex-wrap: nowrap;
			margin: 10px auto;
			align-items: center;
			padding-bottom: 10px;
			img {
				margin-right: 20px;
				margin-bottom: 0px;
				max-height: 45px;
			}
		}
	}
`;
